/**
 * 閲覧記録(access_logs)の表示用の整形(#13)。
 *
 * 記録は認可プロキシ(viewer/server.mjs の recordAccess)が書く。
 * kind は配信の種別("dishes" = マニュアル、"materials" = 素材、"evaluations" = 評価結果)、
 * path は GCS 上のオブジェクトのパス。画面では「何を見たか」を短い言葉にして出す。
 */

export interface AccessLogDoc {
  uid: string;
  email?: string | null;
  kind: string;
  targetId: string;
  path: string;
  at?: { toDate(): Date } | null;
}

/** 何を見たか。ラベルは画面で翻訳する日本語、file は末尾のファイル名 */
export function describeAccess(kind: string, path: string): { label: string; file: string } {
  const file = path.split("/").pop() ?? path;
  if (kind === "materials") return { label: "素材", file };
  if (kind === "evaluations") return { label: "評価結果", file };
  if (/\.mp4$/i.test(path)) return { label: "工程の動画", file };
  return { label: "マニュアル", file };
}
